import { render, staticRenderFns } from "./informationConfirmation.vue?vue&type=template&id=51aef552&scoped=true"
import script from "./informationConfirmation.vue?vue&type=script&lang=js"
export * from "./informationConfirmation.vue?vue&type=script&lang=js"
import style0 from "./informationConfirmation.vue?vue&type=style&index=0&id=51aef552&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aef552",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51aef552')) {
      api.createRecord('51aef552', component.options)
    } else {
      api.reload('51aef552', component.options)
    }
    module.hot.accept("./informationConfirmation.vue?vue&type=template&id=51aef552&scoped=true", function () {
      api.rerender('51aef552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/mobilePreview/components/informationConfirmation.vue"
export default component.exports